// extracted by mini-css-extract-plugin
module.exports = {"header":"MainNavigation_header__2uN33","logo":"MainNavigation_logo__FKrM5","nav":"MainNavigation_nav__2-xSD","active":"MainNavigation_active__2znsL"};